<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '创建应用' : '编辑应用' }}
                </h1>
                <span v-if="!isCreate && platformLabel" class="resourceFormPage__typeReadonly">
                  {{ platformLabel }}
                </span>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main ref="formMain" class="resourceFormPage__main main appFormPage__main">
            <app-form-shell
              :rule-form="ruleForm"
              :is-create="isCreate"
              @icon-uploaded="validateIconField"
            />
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { createApp, editApp, getAppById } from '../../../api/appManage'
import AppFormShell from './AppFormShell.vue'
import {
  APP_FORM_RULES,
  createEmptyAppRuleForm,
  mapAppDetailToForm,
} from './appFormConstants'
import { getPlatformLabel } from './appListHelpers'

export default {
  name: 'AppCreateOrEdit',
  components: {
    AppFormShell,
  },
  data() {
    return {
      isCreate: true,
      loading: false,
      buttonLoading: false,
      ruleForm: createEmptyAppRuleForm(),
      rules: APP_FORM_RULES,
    }
  },
  computed: {
    platformLabel() {
      return getPlatformLabel(this.ruleForm.platform)
    },
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (!this.isCreate) {
      this.loadAppDetail()
    }
  },
  methods: {
    loadAppDetail() {
      this.loading = true
      getAppById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm = mapAppDetailToForm(res.data)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateIconField() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField('icon')
      }
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.info('请完整填写表单')
          return
        }
        const payload = { ...this.ruleForm }
        // 去掉所有空包名/纯空格；indexOf+splice 只删第一个，多次「添加」会漏
        payload.packageList = (payload.packageList || [])
          .map((item) => String(item == null ? '' : item).trim())
          .filter(Boolean)
        this.buttonLoading = true
        const request = this.isCreate
          ? createApp(payload)
          : editApp(payload, this.$route.params.id)
        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '创建成功' : '保存成功')
              this.$router.push('/channel/app/list')
            }
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/channel/app/list')
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.collectionModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.collectionModule >>> .main {
  background: transparent;
}
</style>
